module.exports = __webpack_public_path__ + "img/zoom-out-icon.7bd87740.svg";